import {
  INIT_APP, INIT_PROTOCOL, UPDATE_BOTTOM_BUTTONS,
  ENABLE_OVERFLOW_SCROLLING, HANDLE_CHAT_ROOM_CONNECTION,
  OPEN_MODAL_DIALOG, CLOSE_MODAL_DIALOG,
  SHOW_WAIT_MESSAGE, HIDE_WAIT_MESSAGE,
  START_WAIT_MESSAGE_TIMER, CANCEL_WAIT_MESSAGE_TIMER,
  SET_DEFAULT_SYSTEM_MESSAGES, UPDATE_SYSTEM_MESSAGES,
  UPDATE_TITLE,
  UPDATE_PLACEHOLDER
} from '../../actions/chat-root/index';
import { TOGGLE_FONTSIZE } from '../../actions/chat-header/index';
import { merge } from 'lodash';
import { getUUID } from '../../utils/getUUID';
import { updateMessageMap } from '../../utils/validations/validations';

const defaultSystemMessages = {
  // common
  reset: 'リセット',
  required: '入力必須',
  copy: 'コピー',
  close: '閉じる',
  send: '送信',
  cancel: '中止',
  // text copy
  textCopyCompleted: 'テキストがコピーされました',
  // form
  selectedQuantity: '10個選択済',
  minimumCharacterCount: '最小文字数',
  characters: '10文字',
  formSubmitted: 'フォームを送信しました',
  formUpdated: 'フォームを更新しました',
  submitForm: 'フォームを送信',
  updateForm: 'フォームを更新',
  validationRequired: '入力必須の項目です',
  validationMinWords: '10文字以上の入力が必要です',
  validationMaxWords: '10文字以下の入力にする必要があります',
  validationMinCount: '10個以上の選択にする必要があります',
  validationMaxCount: '10個以下の選択にする必要があります',
  validationPhoneNum: '正しい電話番号の書式ではないようです',
  validationOnlyNumbers: '数字以外の文字が含まれています',
  validationMailAddress: '正しいEメールアドレスの書式ではないようです',
  validationDate: '正しい日付の書式ではないようです',
  validationDateRange: '無効な日付',
  validationZipcode: '正しい郵便番号の書式ではないようです',
  // location
  sentLocationSuccess: '現在の位置情報を送信しました',
  sentLocationFail: '位置情報を送信することができませんでした',
  // chat footer
  sendMessageInstruction: 'Shift + Enterで送信',
  // wait message
  waitingServerResponse: [
    "回答ありがとうございます。",
    "===================",
    "AIコールセンターではお客様の様々なご要望を受けできるように、日々成長中です。",
    "至らない点がありましたら、コールセンターにご連絡ください。",
    "===================",
    "それでは引き続きご案内いたします。",
  ].join("<br>"),
  // translation
  languageSelected: '言語を設定'
};

const updateValidationMessageMap = (systemMessages) => {
  updateMessageMap({
    required: systemMessages.validationRequired,
    minWords: systemMessages.validationMinWords,
    maxWords: systemMessages.validationMaxWords,
    minCount: systemMessages.validationMinCount,
    maxCount: systemMessages.validationMaxCount,
    phoneNum: systemMessages.validationPhoneNum,
    onlyNumbers: systemMessages.validationOnlyNumbers,
    mailAddress: systemMessages.validationMailAddress,
    date: systemMessages.validationDate,
    zipcode: systemMessages.validationZipcode
  });
};

export const initialState = {
  // initApp params
  // initApp params -- base features
  title: 'WebPlugin',
  baseParams: {
    headerFontSize: undefined,
    headerTextColor: undefined,
    headerTextShadow: undefined,
    clientPromptColor: undefined,
    clientPromptBackgroundColor: undefined,
    botPromptColor: undefined,
    botPromptBackgroundColor: undefined,
    buttonColor: undefined,
    buttonBackgroundColor: undefined,
    inputPlaceholder: '',
    buttonLabelAlign: '',
  },
  systemMessages: { ...defaultSystemMessages },
  clientSrc: '',
  operatorSrc: '',
  botSrcDef: '',
  botSrc1: '',
  botSrc2: '',
  botSrc3: '',
  debugFunc: () => { },
  closeFunc: () => { },
  loadSuggestedQuestions: () => { },
  // initApp params -- option features
  canUnfurl: false,
  enableMobileTextCopy: false,
  hideCloseButton: false,
  hideFileButton: false,
  hideFooterCompanyLink: false,
  hideGeolocationButton: false,
  hideHeader: false,
  showTextCount: false,
  useWaitMessage: false,
  waitMessageTimeout: 5000,
  webPluginMode: 'default',
  withoutDate: false,
  withoutForm: false,

  protocol: () => () => { },
  buttons: [],
  canSetOverflowScrolling: false,
  isChatRoomConnected: false,
  isModalDialogOpen: false,
  isWaitMessageShown: false,
  modalDialogMessage: '',
  waitMessageTimerId: null,

  fontSize: null,
  presetFontSize: null,
  useFontSizeToggle: false,
  singlePageMode: false,
  tabId: getUUID(),

  components: {
    HeaderContent: null
  }
};

export default function (state = initialState, action) {
  switch (action.type) {
    case INIT_APP:
      return initApp(state, action);
    case INIT_PROTOCOL:
      return initProtocol(state, action.protocol);
    case UPDATE_BOTTOM_BUTTONS:
      return updateBottomButtons(state, action.data);
    case ENABLE_OVERFLOW_SCROLLING:
      return enableOverflowScrolling(state);
    case HANDLE_CHAT_ROOM_CONNECTION:
      return handleChatRoomConnection(state, action.isChatRoomConnected);
    case OPEN_MODAL_DIALOG:
      return { ...state, isModalDialogOpen: true, modalDialogMessage: action.message };
    case CLOSE_MODAL_DIALOG:
      return { ...state, isModalDialogOpen: false, modalDialogMessage: '' };
    case SHOW_WAIT_MESSAGE:
      return { ...state, isWaitMessageShown: true };
    case HIDE_WAIT_MESSAGE:
      return { ...state, isWaitMessageShown: false };
    case START_WAIT_MESSAGE_TIMER:
      return { ...state, waitMessageTimerId: action.id };
    case CANCEL_WAIT_MESSAGE_TIMER:
      return { ...state, waitMessageTimerId: null };
    case SET_DEFAULT_SYSTEM_MESSAGES:
      updateValidationMessageMap(defaultSystemMessages);
      return { ...state, systemMessages: Object.assign({}, defaultSystemMessages) }
    case UPDATE_SYSTEM_MESSAGES:
      updateValidationMessageMap(action.systemMessages);
      return { ...state, systemMessages: Object.assign({}, state.systemMessages, action.systemMessages) }
    case TOGGLE_FONTSIZE:
      return { ...state, fontSize: action.fontSize }
    case UPDATE_TITLE:
      return { ...state, title: action.title }
    case UPDATE_PLACEHOLDER:
      return { ...state, baseParams: { ...state.baseParams, inputPlaceholder: action.placeholder } }
    default:
      return state;
  }

  function initApp(state, params) {
    return merge({}, state, params);
  }

  function initProtocol(state, protocol) {
    return { ...state, protocol: protocol };
  }

  function updateBottomButtons(state, data) {
    return { ...state, buttons: data };
  }

  function enableOverflowScrolling(state) {
    return { ...state, canSetOverflowScrolling: true };
  }

  function handleChatRoomConnection(state, isConnected) {
    return { ...state, isChatRoomConnected: isConnected };
  }
}
